import { createAction } from 'lib/actions';

export const FETCH_ALL = "TEACHERS/FETCH_ALL";

export function fetchAll() {
  return createAction(FETCH_ALL);
}

// SCHOOLS

export const FETCH_SCHOOLS = "TEACHERS/FETCH_SCHOOLS";
export const FETCH_SCHOOLS_COMPLETED = "TEACHERS/FETCH_SCHOOLS_COMPLETED";
export const SET_LAST_SCHOOL = "TEACHERS/SET_LAST_SCHOOL";

export function fetchSchools() {
  return createAction(FETCH_SCHOOLS, false);
}

export function fetchSchoolsSucceeded(schools, migratedSchools) {
  return createAction(FETCH_SCHOOLS_COMPLETED, false, { schools, migratedSchools });
}

export function setLastSchool(schoolID) {
  return createAction(SET_LAST_SCHOOL, false, { schoolID });
}

// MESSAGES

export const FETCH_MESSAGES = "TEACHERS/FETCH_MESSAGES";
export const FETCH_MESSAGES_COMPLETED = "TEACHERS/FETCH_MESSAGES_COMPLETED";
export const MERGE_MESSAGES = "TEACHERS/MERGE_MESSAGES";
export const SET_REPLY_DRAFT = "TEACHERS/SET_REPLY_DRAFT";
export const SEND_REPLY = "TEACHERS/SEND_REPLY";
export const ADD_PENDING_REPLY = "TEACHERS/ADD_PENDING_REPLY";
export const RETRY_PENDING_REPLY = "TEACHERS/RETRY_PENDING_REPLY";
export const SET_PENDING_REPLY_STATUS = "TEACHERS/SET_PENDING_REPLY_STATUS";
export const MARK_MESSAGES_READ = "TEACHERS/MARK_MESSAGES_READ";
export const MARK_SCHOOL_MESSAGES_READ = "TEACHERS/MARK_SCHOOL_MESSAGES_READ";
export const GO_TO_MESSAGE = "TEACHERS/GO_TO_MESSAGE";
export const CLEAR_GO_TO_MESSAGE = "TEACHERS/CLEAR_GO_TO_MESSAGE";

export function fetchMessages() {
  return createAction(FETCH_MESSAGES, false);
}

export function fetchMessagesSucceeded(messages) {
  return createAction(FETCH_MESSAGES_COMPLETED, false, { messages });
}

export function mergeMessages() {
  return createAction(MERGE_MESSAGES, false);
}

export function setReplyDraft(schoolID, body) {
  return createAction(SET_REPLY_DRAFT, false, {schoolID, body})
}

export function sendReply(schoolID, body) {
  return createAction(SEND_REPLY, false, {schoolID, body})
}

export function addPendingReply(pendingReplyID, pendingReply) {
  return createAction(ADD_PENDING_REPLY, false, { pendingReplyID, pendingReply });
}

export function retryPendingReply(pendingReplyID) {
  return createAction(RETRY_PENDING_REPLY, false, { pendingReplyID });
}

export function setPendingReplyStatus(pendingReplyID, status) {
  return createAction(SET_PENDING_REPLY_STATUS, false, { pendingReplyID, status });
}

export function markMessagesRead(messageIDs) {
  return createAction(MARK_MESSAGES_READ, false, { messageIDs });
}

export function markSchoolMessagesRead(schoolID) {
  return createAction(MARK_SCHOOL_MESSAGES_READ, false, { schoolID });
}

export function goToMessage(messageID) {
  return createAction(GO_TO_MESSAGE, false, { messageID });
}

export function clearGoToMessage() {
  return createAction(CLEAR_GO_TO_MESSAGE);
}

// NOTICES

export const FETCH_NOTICES = "TEACHERS/FETCH_NOTICES";
export const FETCH_NOTICES_COMPLETED = "TEACHERS/FETCH_NOTICES_COMPLETED";
export const SET_EXPANDED_NOTICE = "TEACHERS/SET_EXPANDED_NOTICE";
export const GO_TO_NOTICE = "TEACHERS/GO_TO_NOTICE";
export const CLEAR_GO_TO_NOTICE = "TEACHERS/CLEAR_GO_TO_NOTICE";

export function fetchNotices() {
  return createAction(FETCH_NOTICES, false);
}

export function fetchNoticesSucceeded(notices) {
  return createAction(FETCH_NOTICES_COMPLETED, false, { notices });
}

export function setExpandedNotice(noticeID) {
  return createAction(SET_EXPANDED_NOTICE, false, { noticeID });
}

export function goToNotice(noticeID) {
  return createAction(GO_TO_NOTICE, false, { noticeID });
}

export function clearGoToNotice() {
  return createAction(CLEAR_GO_TO_NOTICE);
}

// TERMS

export const FETCH_TERMS = "TEACHERS/FETCH_TERMS";
export const FETCH_TERMS_COMPLETED = "TEACHERS/FETCH_TERMS_COMPLETED";

export function fetchTerms() {
  return createAction(FETCH_TERMS, false);
}

export function fetchTermsSucceeded(terms) {
  return createAction(FETCH_TERMS_COMPLETED, false, { terms });
}

// APP Guide
export const OPEN_GUIDE = "TEACHERS/OPEN_GUIDE";
export const CLOSE_GUIDE = "TEACHERS/CLOSE_GUIDE";
export function openGuide() {
  return createAction(OPEN_GUIDE);
}
export function closeGuide() {
  return createAction(CLOSE_GUIDE);
}



// WEBPACK FOOTER //
// ./src/state/teachers/actions.js